// Reveal through nested list scrollers as well as the document, leaving room for the guide.
export function revealTourTarget(target: HTMLElement, space: { top: number; bottom: number }): void {
  target.scrollIntoView({ behavior: 'instant' as ScrollBehavior, block: 'center', inline: 'nearest' });
  const delta = (scroller?: HTMLElement) => {
    const box = target.getBoundingClientRect();
    const port = scroller?.getBoundingClientRect();
    const top = port ? Math.max(space.top, port.top + scroller!.clientTop) : space.top;
    const bottom = port ? Math.min(space.bottom, port.top + scroller!.clientTop + scroller!.clientHeight) : space.bottom;
    const available = Math.max(0, bottom - top);
    const desiredTop = top + Math.max(0, (available - box.height) / 2);
    return box.top - desiredTop;
  };
  for (let parent = target.parentElement; parent && parent !== document.scrollingElement; parent = parent.parentElement) {
    if (/(auto|scroll|hidden)/.test(getComputedStyle(parent).overflowY) && parent.scrollHeight > parent.clientHeight) {
      parent.scrollBy({ top: delta(parent), behavior: 'instant' as ScrollBehavior });
    }
  }
  window.scrollBy({ top: delta(), behavior: 'instant' as ScrollBehavior });
}

export function visibleTourTarget(target: HTMLElement, space: { top: number; bottom: number; left: number; right: number }): { top: number; left: number; width: number; height: number } | null {
  const box = target.getBoundingClientRect();
  let top = Math.max(space.top, box.top), bottom = Math.min(space.bottom, box.bottom);
  let left = Math.max(space.left, box.left), right = Math.min(space.right, box.right);
  for (let parent = target.parentElement; parent && parent !== document.scrollingElement; parent = parent.parentElement) {
    const style = getComputedStyle(parent), port = parent.getBoundingClientRect();
    if (style.overflowY !== 'visible') {
      top = Math.max(top, port.top + parent.clientTop);
      bottom = Math.min(bottom, port.top + parent.clientTop + parent.clientHeight);
    }
    if (style.overflowX !== 'visible') {
      left = Math.max(left, port.left + parent.clientLeft);
      right = Math.min(right, port.left + parent.clientLeft + parent.clientWidth);
    }
  }
  return bottom > top && right > left ? { top, left, width: right - left, height: bottom - top } : null;
}
